import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

export type SelectableTextTheme = 'dark' | 'light';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-selectable-text',
  templateUrl: './selectable-text.component.html',
})
export class SelectableTextComponent {
  public readonly theme = input.required<SelectableTextTheme>();
  public readonly text = input.required<string>();
  public readonly isSelected = input.required<boolean>();
}
